import styled from 'styled-components'

export const StyledDynamicVideo = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
`
export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const VideoStyle = {
  width: '100%',
  height: '100%',
  zIndex: 'auto',
}
